
import { useEffect } from "react";
import { MainNav } from "@/components/MainNav";
import { PriceAlertForm } from "@/components/price-alert";
import { PriceAlertsList } from "@/components/PriceAlertsList";
import { useStore } from "@/store/useStore";
import { useAuthContext } from "@/contexts/auth";
import { MetalPriceCard } from "@/components/MetalPriceCard";
import { PageSEO } from "@/components/PageSEO";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Alerts = () => {
  const { 
    fetchCurrentPricesData, 
    currentGoldPrice,
    currentSilverPrice,
  } = useStore();
  
  const { user, isAuthenticated } = useAuthContext();

  // Debug log per lo stato di autenticazione
  useEffect(() => {
    console.log('[AlertsPage] Authentication state:', {
      userExists: !!user,
      userId: user?.id,
      isAuthenticated
    });
  }, [user, isAuthenticated]);

  useEffect(() => {
    fetchCurrentPricesData();
    
    // Aggiorna i prezzi periodicamente
    const interval = setInterval(() => {
      fetchCurrentPricesData();
    }, 30000);
    
    return () => clearInterval(interval);
  }, [fetchCurrentPricesData]);

  return (
    <div className="min-h-screen flex flex-col">
      <PageSEO 
        title="Avvisi di Prezzo per Oro e Argento - Gildy"
        description="Imposta avvisi personalizzati per i prezzi dell'oro e dell'argento. Ricevi notifiche quando i metalli preziosi raggiungono il tuo prezzo target."
        canonicalPath="/avvisi"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Avvisi di Prezzo per Oro e Argento",
          "description": "Imposta avvisi personalizzati per i prezzi dell'oro e dell'argento.",
          "mainEntity": {
            "@type": "Service",
            "name": "Avvisi di Prezzo per Metalli Preziosi",
            "description": "Servizio di notifica per i cambiamenti di prezzo dell'oro e dell'argento.",
            "provider": {
              "@type": "Organization",
              "name": "Gildy"
            },
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "EUR"
            }
          }
        }}
      />
      
      <MainNav />
      <main className="flex-1 container mx-auto py-6 px-4 md:px-6">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2">Avvisi di Prezzo</h1>
          <p className="text-muted-foreground">
            Ricevi notifiche quando i prezzi dei metalli raggiungono i tuoi obiettivi
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <MetalPriceCard 
            metalPrice={currentGoldPrice} 
            isLoading={!currentGoldPrice}
            metalType="gold"
          />
          <MetalPriceCard 
            metalPrice={currentSilverPrice} 
            isLoading={!currentSilverPrice}
            metalType="silver"
          />
        </div>
        
        {isAuthenticated ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <PriceAlertForm />
            <PriceAlertsList />
          </div>
        ) : (
          <div className="mt-8 p-6 border rounded-lg bg-muted/20 text-center">
            <h3 className="text-xl font-medium mb-2">Monitora i Prezzi dei Metalli Preziosi</h3>
            <p className="mb-6">
              Crea un account per impostare avvisi personalizzati e ricevere notifiche quando i prezzi di oro o argento raggiungono i tuoi obiettivi.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild className="bg-primary text-white px-6 py-2 rounded-md">
                <Link to="/auth/register">Registrati Ora</Link>
              </Button>
              <Button asChild variant="outline" className="px-6 py-2 rounded-md">
                <Link to="/auth/login">Accedi</Link>
              </Button>
            </div>
            <p className="mt-6 text-sm text-muted-foreground">
              La registrazione è gratuita e ti permette di accedere a tutte le funzionalità di Gildy.
            </p>
          </div>
        )}
      </main>
    </div>
  );
};

export default Alerts;
